export enum Fonts {
  body2 = '600 14px/1 \'Open Sans\', sans-serif',
  caption = '600 11px/1 \'Open Sans\', sans-serif',
}